export default __webpack_public_path__ + "static/tg-55de1c7e772fa5ffff7f0bcc9044056e.svg";